import { computed, toValue } from 'vue';
import { useQuery } from '@tanstack/vue-query';

import http from '@/services/http';
import { queryKeys } from '@/queries/_shared/queryKeys';

export async function fetchGroupById(id) {
  const response = await http.get(`/groups/${id}`);
  return response.data;
}

export function useGroupQuery(id, options = {}) {
  return useQuery({
    queryKey: computed(() => queryKeys.groups.byId(toValue(id))),
    queryFn: () => fetchGroupById(toValue(id)),
    enabled: computed(() => Boolean(toValue(id))),
    ...options
  });
}
